import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HeroHeadersBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { primaryBlockDefaultStyles } from "../../constants";
import { HomepageBlock1 as Block } from "./HomepageBlock1";
import { defaultData } from "./HomepageBlock1DefaultData";
import imagePreview from "./homepage_block_1_preview.png";

export const HomepageBlock1: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Homepage Block 1",
    nameI18n: "builder_ui.block_type.homepage.block_1",
    version: 1,
    category: [HeroHeadersBlock],
    props: {
      leftContent: {
        name: "Left Content",
        nameI18n: "builder_ui.prop_type.left_content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      rightContent: {
        name: "Right Content",
        nameI18n: "builder_ui.prop_type.right_content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      buttons: {
        name: "Buttons",
        nameI18n: "builder_ui.prop_type.buttons",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        type: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            defaultValue: "var(--theme-website-color-6)",
            category: [DesignProp, GeneralProp],
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            defaultValue: {
              paddingTop: "0",
              paddingRight: "0",
              paddingBottom: "0",
              paddingLeft: "0",
            },
            category: [DesignProp, PaddingsProp],
          },
          margin: {
            ...margin,
            defaultValue: primaryBlockDefaultStyles.margin,
            category: [DesignProp, MarginsProp],
          },
        },
      },
    },
  },
};
